
import { get } from "@rails/request.js"

export function subscribe()
{
  if (window.app.incomingPaymentsChannelSubscriptions == null) {

    window.app.incomingPaymentsChannelSubscriptions = window.app.consumer.subscriptions.create({
      channel: "IncomingPaymentsChannel"
    },
    {
      received: update,
    })
  }
  
  return window.app.incomingPaymentsChannelSubscriptions;
}

export function unsubscribe(){
  if (window.app.incomingPaymentsChannelSubscriptions != null) {
    window.app.incomingPaymentsChannelSubscriptions.unsubscribe();
    window.app.incomingPaymentsChannelSubscriptions = null;
  }
}

async function update() {

  const updateDiv = document.getElementById("incoming-payments-div");
  const url = updateDiv.getAttribute("data-update-url");

  const response = await get(url);

  if (response.ok)
    updateDiv.innerHTML = await response.text;

}
